// extracted by mini-css-extract-plugin
module.exports = {"teaser":"post-teaser-module--teaser--5TCQJ","more":"post-teaser-module--more--2uSQi","tags":"post-teaser-module--tags--1iVO_","date":"post-teaser-module--date--vPz-0"};